<app-navbar-style-one></app-navbar-style-one>

<div class="inner-banner">
    <div class="container">
        <div class="inner-title text-center">
            <h3>تفاصيل الطلب</h3>
        </div>
    </div>
</div>
<div class="alert alert-danger text-center" *ngIf="showError" style="position: fixed;top: 20%;direction: ltr;left: 50%;transform: translate(-50%, -50%);z-index: 99999999999999;">
    {{errorMsg}}
</div>
<section class="checkout-area pt-100 pb-70">
    <div class="container">
        <div class="address-container" dir="rtl">
            <h3 class="section-title">تفاصيل الطلب #{{orderDetails?.orderId}}</h3>
            
            <!-- Vendor Info -->
            <div class="vendor-card">
                <img [src]="orderDetails?.vendor?.avatar || './assets/img/logo.ico'" 
                     class="vendor-avatar" 
                     (error)="handleImageError($event)">
                <div class="vendor-info">
                    <h4>{{orderDetails?.vendor?.name}}</h4>
                    <div class="order-status" [ngClass]="{
                        'status-ordered': orderDetails?.status != 'canceled',
                        'status-canceled': orderDetails?.status === 'canceled'
                    }">
                        {{ orderDetails?.status | titlecase }}
                    </div>
                </div>
            </div>

            <!-- Order Summary -->
            <div class="order-summary">
                <div class="summary-item">
                    <span class="summary-label">تاريخ الطلب:</span>
                    <span class="summary-value">{{orderDetails?.orderedAt | date:'dd/MM/yyyy'}}</span>
                </div>

                <div class="summary-item">
                    <span class="summary-label">وقت الطلب:</span>
                    <span class="summary-value">{{orderDetails?.orderedAt | date:'hh:mm a'}}</span>
                </div>
                
                <div class="summary-item" *ngIf="orderDetails?.address">
                    <span class="summary-label">عنوان التوصيل:</span>
                    <span class="summary-value">{{orderDetails?.address}}</span>
                </div>
                
                <div class="summary-item">
                    <span class="summary-label">طريقة الدفع:</span>
                    <span class="summary-value">
                        {{orderDetails?.paymentMethod === 'cash' ? 'الدفع عند الاستلام' : 'بطاقة ائتمانية'}}
                    </span>
                </div>
                
                <div class="summary-item" *ngIf="orderDetails?.deliveryNote">
                    <span class="summary-label">ملاحظات:</span>
                    <span class="summary-value">{{orderDetails?.deliveryNote}}</span>
                </div>
            </div>

            <!-- Products List -->
            <div class="products-list">
                <h4 class="list-title">المنتجات</h4>
                <div class="product-item row" *ngFor="let product of orderDetails?.products">
                    <div class="product-info col-4">
                        <h5>{{product.name}}</h5>
                        <small>{{product.type}}</small>
                    </div>
                    <div class="product-quantity col-4">
                        {{product.quantity}} × {{product.price | currency:'EGP':'symbol':'1.0-0'}}
                    </div>
                    <div class="product-total col-4">
                        {{product.quantity * product.price | currency:'EGP':'symbol':'1.0-0'}}
                    </div>
                </div>
            </div>

            <!-- Order Total -->
            <div class="order-total">
                <div class="total-row">
                    <span>المجموع</span>
                    <span>{{orderDetails?.totalCost | currency:'EGP':'symbol':'1.0-0'}}</span>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- <app-footer-style-two></app-footer-style-two> -->